import { ModalWrapper } from "@/components/modals/modal-wrapper";
import { popModal } from "@/stores/modal";
import { Button } from "@/toggle-ui-kit/button";

interface ResetChangesConfirmModalProps {
  onConfirm: () => void;
}

export const ResetChangesConfirmModal = ({
  onConfirm,
}: ResetChangesConfirmModalProps) => {
  const handleConfirm = () => {
    popModal();
    onConfirm();
  };

  return (
    <ModalWrapper className="flex w-[548px] flex-col gap-0 rounded-[10px] border border-line-normal bg-background-base p-0 shadow-2xl">
      <div className="flex flex-col gap-4 px-6 pb-5 pt-6">
        <h2 className="headline-1-semibold text-label-normal">
          수정한 값을 모두 초기화할까요?
        </h2>
        <p className="body-2-normal-regular text-label-alternative">
          수정된 항목이 편집 전 상태로 돌아갑니다.
          <br />
          전체 초기화 후에는 수정 내용을 복구할 수 없습니다.
        </p>
      </div>

      <div className="flex justify-end gap-2 px-6 pb-6">
        <Button
          variant="outlined"
          color="secondary"
          size={36}
          onClick={popModal}
          className="min-w-[58px]"
        >
          취소
        </Button>
        <Button
          variant="solid"
          color="primary"
          size={36}
          onClick={handleConfirm}
          className="min-w-[90px] bg-status-negative"
        >
          전체 초기화
        </Button>
      </div>
    </ModalWrapper>
  );
};
